import { Grid, Box, Typography, Button } from '@mui/material';
import './SelectRoom.styles.css';
import { roomData } from '../room.data';
import NavigationSteps from '../../../../components/NavigationSteps/NavigationSteps.components';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { useAppSelector } from '../../../../store/hooks';
import { useEffect } from 'react';
import KeyboardArrowLeftOutlinedIcon from '@mui/icons-material/KeyboardArrowLeftOutlined';
import leftIcon from '../../../../assets/images/LeftIcon.png';

const SelectRoom = ({
  dialog,
  setRoomSceneDimension,
  roomViewDialogClose,
}: {
  dialog?: boolean | undefined;
  setRoomSceneDimension?: (dimension: { height: number; width: number } | null) => void;
  roomViewDialogClose?: () => void;
}) => {
  const navigate = useNavigate();
  const stepsData = { step: '3', label: 'Select a Room' };
  const { selectedGroutColorData, selectedTileData } = useAppSelector((state) => state.tile);
  const params = useParams();
  const location = useLocation();

  const handleVisualize = (room: { id: string }) => {
    if (room.id !== params.room) {
      if (dialog) {
        setRoomSceneDimension?.(null);
        roomViewDialogClose?.();
      }
      navigate(`../visualizer/${room.id}/view`);
    }
  };

  const handleBack = () => {
    navigate('../visualizer/configure-tile/grout-colors');
  };

  useEffect(() => {
    if (!location.hash) {
      window.scrollTo(0, 0);
    }
  }, [location]);
  return (
    <Grid container direction="row" columnSpacing={4} className="GridRow SelectRoomRow">
      {!dialog && (
        <NavigationSteps
          stepsData={stepsData}
          // handleClick={handleClick}
          handleBack={() => {
            if (selectedGroutColorData) {
              navigate('../visualizer/configure-tile/grout-colors');
            } else {
              navigate('../');
            }
          }}
          forward
        />
      )}
      {selectedTileData ? (
        roomData.map((item) => (
          <Grid
            key={item.id}
            size={{ xs: 12, md: 4 }}
            className="LoopRoomBox"
            onClick={() => handleVisualize(item)}
          >
            <Box className="RoomItemBox" id={item.name}>
              <Box className={`RoomBox ${params.room === item.id ? 'Selected' : ''}`}>
                <Box className="RoomContent">
                  <img src={item.thumbnail} alt="" />
                  <Box className="RoomHeadingBox">
                    <Typography variant="h3" className="RoomHeading">
                      {item.name}
                    </Typography>
                  </Box>
                  <Box className="RoomName">
                    {/* <Typography variant="h4" className="SceneName">
                    Image placeholder
                  </Typography> */}
                    <Button variant="contained" className="VisualizeButton" color="primary">
                      <img src={leftIcon} alt="" />{' '}
                      Visualize It
                    </Button>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Grid>
        ))
      ) : (
        <p>Please go back and select tile</p>
      )}
      <Grid size={{ xs: 12 }} className="BottomNextButton">
        <Button
          variant="contained"
          color="primary"
          startIcon={<KeyboardArrowLeftOutlinedIcon />}
          onClick={handleBack}
        >
          Back
        </Button>
      </Grid>
    </Grid>
  );
};

export default SelectRoom;
